import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgRemovedPageContent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M94.507 28.546H21.865A3.365 3.365 0 0 0 18.5 31.91v57.796a3.365 3.365 0 0 0 3.365 3.365h72.642a3.365 3.365 0 0 0 3.365-3.365V31.91a3.365 3.365 0 0 0-3.365-3.364Z"
        fill="#fff"
      />
      <path
        d="M21.865 28.546h72.642a3.364 3.364 0 0 1 3.365 3.364v3.878H18.5V31.91a3.364 3.364 0 0 1 3.365-3.364Z"
        fill="#78B441"
      />
      <path
        d="M17.7 88.865V76.963a.8.8 0 1 1 1.6 0v11.902a3.408 3.408 0 0 0 3.406 3.407h70.96a3.408 3.408 0 0 0 3.406-3.407V35.788a.8.8 0 1 1 1.6 0v53.077a5.007 5.007 0 0 1-5.006 5.006h-70.96a5.007 5.007 0 0 1-5.006-5.006Z"
        fill="#0F172A"
      />
      <path
        d="M22.966 33.265a1.102 1.102 0 1 0 0-2.204 1.102 1.102 0 0 0 0 2.204ZM27.383 33.265a1.102 1.102 0 1 0 0-2.204 1.102 1.102 0 0 0 0 2.204ZM31.799 33.265a1.102 1.102 0 1 0 0-2.204 1.102 1.102 0 0 0 0 2.204Z"
        fill="#599F40"
      />
      <path
        d="M48.252 46.487c0-.807.656-1.471 1.472-1.471H89.46c.816 0 1.472.656 1.472 1.471v14.687c0 .808-.656 1.472-1.472 1.472H49.724a1.468 1.468 0 0 1-1.472-1.472V46.487ZM25.44 70.352c0-1.018.824-1.834 1.842-1.834H89.09a1.84 1.84 0 0 1 1.842 1.834 1.84 1.84 0 0 1-1.842 1.833H27.282a1.84 1.84 0 0 1-1.843-1.833ZM25.44 76.963c0-1.018.824-1.834 1.842-1.834H89.09a1.84 1.84 0 0 1 1.842 1.834 1.84 1.84 0 0 1-1.842 1.834H27.282a1.84 1.84 0 0 1-1.843-1.834ZM25.44 83.575c0-1.018.824-1.834 1.842-1.834H89.09a1.84 1.84 0 0 1 1.842 1.834 1.84 1.84 0 0 1-1.842 1.833H27.282a1.84 1.84 0 0 1-1.843-1.834Z"
        fill="#E2E8F0"
      />
      <path
        d="M107.094 19.725a.8.8 0 0 1 1.054 1.205l-5.519 4.828a.8.8 0 0 1-1.053-1.204l5.518-4.829ZM108.066 28.536a.8.8 0 0 1 .506 1.517l-4.139 1.38a.799.799 0 1 1-.505-1.518l4.138-1.38ZM97.968 17.839a.8.8 0 0 1 1.372.822l-2.07 3.45a.8.8 0 1 1-1.37-.824l2.068-3.448Z"
        fill="#0F172A"
      />
      <mask
        id="removed-page-content_svg__a"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={25}
        y={47}
        width={13}
        height={13}
      >
        <path d="M37.746 47.682H25.439v12.306h12.307V47.682Z" fill="#fff" />
      </mask>
      <g mask="url(#removed-page-content_svg__a)">
        <mask
          id="removed-page-content_svg__b"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={25}
          y={47}
          width={13}
          height={13}
        >
          <path d="M37.746 47.682H25.439v12.306h12.307V47.682Z" fill="#fff" />
        </mask>
        <g mask="url(#removed-page-content_svg__b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.742 47.976a1.015 1.015 0 0 1 1.447 0l4.4 4.4 4.399-4.4a1.015 1.015 0 0 1 1.446 0 1.016 1.016 0 0 1 0 1.447l-4.399 4.4 4.4 4.399a1.016 1.016 0 0 1 0 1.446 1.015 1.015 0 0 1-1.447 0l-4.4-4.399-4.399 4.4a1.015 1.015 0 0 1-1.447 0 1.015 1.015 0 0 1 0-1.447l4.4-4.4-4.4-4.399a1.015 1.015 0 0 1 0-1.447Z"
            fill="#E41E3F"
          />
        </g>
      </g>
    </svg>
  )
}
export default wrapIllustration(SvgRemovedPageContent)
